"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetReviewCycleLogSearchServiceResponse", {
    enumerable: true,
    get: function() {
        return GetReviewCycleLogSearchServiceResponse;
    }
});
const _resourcelogs = require("../../resource-logs");
const _base = require("../base");
const GetReviewCycleLogSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _resourcelogs.ResourceLogModel.array()
});
